<!--
 * @Author: gaoxueting
 * @Date: 2020-06-22 16:32:35
 * @LastEditTime: 2020-08-13 16:55:26
 * @LastEditors: fengzhongmei
 * @Description:
 -->
<template>
    <Modal v-model="show"
           :title="modalText.modalTitle"
           width="700">
        <div class="confirm-text">
            <Icon class="icon-prompt-1-o question-icon"></Icon>
            <div class="text">
                <p class="title">{{ modalText.title }}</p>
                <p class="desc">{{ modalText.desc }}</p>
            </div>
        </div>
        <div class="instance">
            <div v-for="item in ips"
                 :key="item"
                 class="check-li">
                <span>{{item}}</span>
            </div>
        </div>
        <div slot="footer">
            <Button type="text"
                    class="ivu-btn-text"
                    @click="cancel">取消</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="clickFun">
                <span>{{loading ? '保存中' : '确定'}}</span>
            </Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api.js'
export default {
    data () {
        return {
            show: false,
            loading: false,
            ids: [],
            ips: [],
            deleteNum: 1,
            modalText: {
                modalTitle: '解绑弹性IP',
                title: `要解绑弹性IP数目:${this.deleteNum}`
                // desc: '请确认您的选择，释放操作将使资源无法恢复'
            }
        }
    },
    methods: {
        openModal (choosed) {
            this.deleteNum = choosed.length
            this.show = true
            this.modalText.title = `要解绑弹性IP数目:  ${this.deleteNum}`
            this.ips = []
            choosed.forEach(item => {
                if (this.ips.indexOf(item.fixedIp) === -1) {
                    this.ips.push(item.fixedIp)
                }
                if (this.ids.indexOf(item.id) === -1) {
                    this.ids.push(item.id)
                }
            })
        },
        cancel () {
            this.show = false
            this.ips = []
        },
        clickFun () {
            const ids = this.ids.join(',')
            this.axios.post(this.urlFormat(API.POST_DETACH_FLOATIP, false), {
                floatingIpIds: ids
            }).then(res => {
                if (res) {
                    this.loading = false
                    this.cancel()
                    this.$emit('refresh')
                    !res.message && this.$Message.info('操作成功')
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.confirm-text {
    margin-bottom: 15px;
    .question-icon {
        font-size: 40px;
        color: #3498dc;
        vertical-align: top;
    }
    .text {
        display: inline-block;
        margin-left: 20px;
        p {
            line-height: 2;
        }
        .title {
            font-size: 14px;
            font-weight: bold;
            color: #333;
        }
        .desc {
            font-size: 12px;
            color: #666;
        }
    }
}
.instance {
    padding: 10px;
    overflow: hidden;
    padding-left: 70px;
    .check-li {
        line-height: 32px;
        overflow: hidden;
        width: 165px;
        margin-right: 10px;
        margin-bottom: 10px;
        float: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
        padding: 3px 5px;
        border: 1px solid #e9e9e9;
    }
}
</style>
